/*
 * Winkelwagen — twee handelingen die het thema zelf niet kent.
 *
 *  1. Maat wijzigen zonder het artikel eerst weg te gooien.
 *  2. Een aanvullend product toevoegen met de plus-knop.
 *
 * Voor het verversen roepen we niets eigens aan: het thema heeft een
 * cart-drawer die naar `cart:refresh` luistert en de lade dan opnieuw
 * opbouwt. Daar sluiten we op aan, zodat de aantallen, het totaal en de
 * verzendbalk vanzelf kloppen.
 */
(function () {
  'use strict';

  var bezig = false;

  function verversen() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function post(pad, gegevens) {
    return fetch(pad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(gegevens)
    }).then(function (antwoord) {
      return antwoord.json().then(function (data) {
        if (!antwoord.ok) throw new Error(data.description || data.message || 'mislukt');
        return data;
      });
    });
  }

  var wortel = (window.theme && window.theme.routes) || {};
  var TOEVOEGEN = wortel.cart_add_url || '/cart/add';
  var WIJZIGEN = wortel.cart_change_url || '/cart/change';

  /*
   * Maat wijzigen.
   *
   * Eerst de nieuwe maat toevoegen en pas daarna de oude regel weghalen.
   * Andersom zou een mislukte toevoeging het artikel uit de winkelwagen laten
   * verdwijnen; nu staat er in het slechtste geval even te veel in.
   *
   * De oude regel spreken we aan op zijn sleutel en niet op zijn plek in de
   * lijst. Deze winkel zet een net toegevoegd artikel bovenaan, waardoor alle
   * regelnummers opschuiven op het moment dat we de nieuwe maat toevoegen —
   * met een nummer haalden we daardoor de zojuist toegevoegde maat weer weg.
   */
  function wisselMaat(keuze) {
    if (bezig) return;
    var nieuw = keuze.value;
    var sleutel = keuze.getAttribute('data-key');
    var aantal = parseInt(keuze.getAttribute('data-qty'), 10) || 1;
    if (!nieuw || !sleutel) return;

    bezig = true;
    keuze.disabled = true;

    post(TOEVOEGEN + '.js', { id: nieuw, quantity: aantal })
      .then(function () {
        return post(WIJZIGEN + '.js', { id: sleutel, quantity: 0 });
      })
      .then(function () {
        verversen();
      })
      .catch(function (fout) {
        // Bij een fout laten we de winkelwagen staan zoals hij was en halen
        // we de echte stand op, zodat het scherm nooit iets anders toont
        // dan wat er werkelijk in het mandje zit.
        console.error('maat wijzigen mislukt:', fout);
        verversen();
      })
      .finally(function () {
        bezig = false;
        keuze.disabled = false;
      });
  }

  function voegToe(knop) {
    if (bezig) return;
    // Staat er een maatkeuze naast, dan telt die en niet de standaardwaarde
    // op de knop.
    var houder = knop.closest('.cart-up__keuze');
    var keuze = houder ? houder.querySelector('[data-cart-up-variant]') : null;
    var variant = keuze ? keuze.value : knop.getAttribute('data-cart-up-add');
    if (!variant) return;

    bezig = true;
    knop.setAttribute('aria-busy', 'true');

    post(TOEVOEGEN + '.js', { id: variant, quantity: 1 })
      .then(function () {
        verversen();
      })
      .catch(function (fout) {
        console.error('toevoegen mislukt:', fout);
        verversen();
      })
      .finally(function () {
        bezig = false;
        knop.removeAttribute('aria-busy');
      });
  }

  // Eén afvanger op de pagina: de lade wordt na elke wijziging opnieuw
  // opgebouwd, dus losse listeners per element zouden telkens verdwijnen.
  document.addEventListener('change', function (g) {
    var keuze = g.target.closest ? g.target.closest('[data-cart-swap]') : null;
    if (keuze) wisselMaat(keuze);
  });

  document.addEventListener('click', function (g) {
    var knop = g.target.closest ? g.target.closest('[data-cart-up-add]') : null;
    if (!knop) return;
    g.preventDefault();
    voegToe(knop);
  });

  /*
   * Vangnet voor de hoogte van de lade.
   *
   * De CSS regelt dit met dvh, maar Safari op de iPhone rekent daar niet
   * altijd mee: bij het openen van de lade staat de balk onderin er soms
   * nog wel en soms niet. visualViewport geeft de hoogte die de bezoeker
   * echt ziet, balken eraf. Die zetten we in --cart-hoogte, zodat de
   * CHECKOUT-knop nooit achter een balk kan vallen.
   */
  function zetLadehoogte() {
    var zicht = window.visualViewport;
    var hoogte = zicht ? zicht.height : window.innerHeight;
    if (!hoogte) return;
    document.documentElement.style.setProperty('--cart-hoogte', Math.round(hoogte) + 'px');
  }

  zetLadehoogte();
  window.addEventListener('resize', zetLadehoogte);
  window.addEventListener('orientationchange', zetLadehoogte);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', zetLadehoogte);
  }
  // De lade wordt na elke wijziging opnieuw opgebouwd; dan opnieuw meten.
  document.addEventListener('cart:refresh', zetLadehoogte);

  /*
   * Scrollen vasthouden binnen de lade.
   *
   * Het thema zet `overflow: hidden` op de pagina zodra de lade opengaat.
   * Safari op de iPhone trekt zich daar niets van aan: zet je je vinger op
   * een deel dat zelf niet scrolt — de kop of het blok met CHECKOUT — dan
   * begint Safari de pagina eronder te verschuiven, en blijft je gebaar
   * daaraan hangen. Daarna scrolt de productenlijst niet meer mee.
   *
   * We laten daarom alleen vingerbewegingen door die in de productenlijst
   * beginnen. Alle andere blokkeren we zolang de lade open is.
   */
  var SCROLLBAAR = 'side-panel-content';
  var ladeCache = null;

  /*
   * Let op: het thema zet bij het openen `open-cart` op de pagina, maar
   * haalt die bij het sluiten nooit weg — alleen `active` en `open-cc`
   * worden opgeruimd. Op `open-cart` afgaan zou betekenen dat de hele
   * site niet meer scrolt zodra de winkelwagen één keer open is geweest.
   * We kijken daarom naar `active` op de lade zelf.
   */
  function openLade() {
    if (!ladeCache || !document.body.contains(ladeCache)) {
      ladeCache = document.querySelector('.side-panel.cart-drawer');
    }
    if (!ladeCache || !ladeCache.classList.contains('active')) return null;
    return ladeCache;
  }

  function magScrollen(element, lade) {
    var knoop = element;
    while (knoop && knoop.nodeType === 1) {
      if (knoop.classList && knoop.classList.contains(SCROLLBAAR)) return true;
      if (knoop === lade) return false;
      knoop = knoop.parentNode;
    }
    return false;
  }

  document.addEventListener('touchmove', function (gebeurtenis) {
    var lade = openLade();
    if (!lade) return;
    // Twee vingers is knijpen om te zoomen; dat laten we met rust.
    if (gebeurtenis.touches && gebeurtenis.touches.length > 1) return;
    if (magScrollen(gebeurtenis.target, lade)) return;
    gebeurtenis.preventDefault();
  }, { passive: false });
})();
